export default "__VITE_PUBLIC_ASSET__338995bc__"